module.exports = __webpack_public_path__ + "static/media/MeuPortalCapemisa_Negativo.ed6e44bb.png";